import { map, propEq, curry, when, mergeLeft } from 'ramda';

/**
 * We want to update an object in an array of objects with the given id and the given values object.
 *
 * If the object does not exist, we return the array as is.
 * If the object exists, we update the initial object with the given values object by merging the values with the existing object.
 *
 * Returns a new array with the updated object.
 *
 * @param {string | number} id - The id of the object to update.
 * @param {Object} values - The fields object to update the object with.
 * @param {Array<Object>} items - The array of objects to update the object in.
 * keywords: Update object, manipulate object, alter object values
 */

interface GenericFn {
  <T>(id: string | number, values: Object, items: Array<T>): Array<T>;
}

const alterObjectById: GenericFn = curry((id, values, items) =>
  map(
    when(propEq(id, 'id'), item => mergeLeft(values, item)),
    items,
  ),
);

export default alterObjectById;
